// Generator de denumire produs + parsere fallback din nume (Admin Produse)
// Numele se compune DOAR din selectoare diferențiatoare — NU include suma min/max sau mențiunile.

export function parseVirareFromName(name = '') {
  const s = (name || '').toLowerCase();
  if (/f[aă]r[aă]\s*(virare|incas)/.test(s)) return false;
  if (/virare|incas(are| )/.test(s)) return true;
  return null;
}

export function parseIncomeFromName(name = '') {
  const m = (name || '').replace(/\./g, '').match(/venit[^0-9]*([0-9]{4,})/i);
  return m ? Number(m[1]) : null;
}

export function parseAvansFromName(name = '') {
  const s = (name || '').toLowerCase();
  if (/avans[^0-9]*20\s*%?\s*[-–]\s*40/.test(s)) return { min: 20, max: 40 };
  if (/avans[^0-9]*(>|≥|>=|peste|mai\s*mare[^0-9]*)\s*40/.test(s)) return { min: 40, max: 100 };
  if (/avans[^0-9]*(≥|>=)\s*25/.test(s)) return { min: 25, max: 100 };
  if (/avans[^0-9]*(<|≤|<=|sub|mai\s*mic[^0-9]*)\s*20/.test(s)) return { min: 0, max: 20 };
  if (/avans[^0-9]*(≥|>=|>|peste|mai\s*mare[^0-9]*)\s*20/.test(s) || /avans\s*20\s*%(?!\s*[-–])/.test(s)) return { min: 20, max: 100 };
  if (/avans[^0-9]*15/.test(s)) return { min: 15, max: 20 };
  return { min: null, max: null };
}

function fmtInt(n) {
  try { return Number(n).toLocaleString('ro-RO'); } catch { return String(n); }
}

// Construiește numele din câmpurile structurate (fără sumă min/max și fără mențiuni)
export function generateProductName(p = {}, bankName = '') {
  const base = [bankName, p.program || 'Ipotecar', p.credit_type === 'refinantare' ? 'Refinanțare' : 'Achiziție']
    .filter(Boolean).join(' ');
  const parts = [base];

  if (p.interest_type === 'variable') {
    parts.push('variabilă');
  } else if (p.fixed_years) {
    parts.push(p.fixed_full_period ? 'fixă toată perioada' : `fix ${p.fixed_years} ani`);
  }

  if (p.energy_class === 'A') parts.push('Clasa A');
  else if (p.energy_class === 'GREEN') parts.push('Verde');
  else if (p.energy_class === 'B/C' || p.energy_class === 'BC') parts.push('B / C');

  if (p.salary_transfer === true) parts.push('cu virare');
  else if (p.salary_transfer === false) parts.push('fără virare');

  if (p.down_payment_min != null && p.down_payment_min !== '') {
    const mn = Number(p.down_payment_min);
    const mx = p.down_payment_max != null && p.down_payment_max !== '' ? Number(p.down_payment_max) : null;
    parts.push(mx != null && mx !== mn && mx < 100 ? `avans ${mn}–${mx}%` : `avans ≥${mn}%`);
  }

  if (p.min_income_required) parts.push(`venit ≥ ${fmtInt(p.min_income_required)} lei`);
  if (p.max_income_allowed) parts.push(`venit < ${fmtInt(p.max_income_allowed)} lei`);

  return parts.join(', ');
}
